/* eslint-disable unicorn/filename-case */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-object-injection */
import React, { useCallback, useEffect, useState, useContext } from 'react';
import { FormattedDate, Icon, Loader, useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { ServiceManager } from '@jutro/legacy/services';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { getNormalizedLOBName } from '@xengage/gw-portals-config-js';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { LobIconUtil } from '@xengage/gw-portals-util-js';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import appConfig from 'app-config';
import { WizardPageTemplate } from 'gw-portals-wizard-components-ui';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import FNOLPolicySearch from 'twia-capability-fnol-common-react/components/FNOLPolicySearch/FNOLPolicySearch';
import messages from '../../FNOL.messages';
import Claim from '../../models/Claim';
import metadata from './FNOLSelectPolicy.metadata.json5';
import styles from './FNOLSelectPolicy.module.scss';

function FNOLSelectPolicy(props) {
    const { showConfirm } = useModal();

    const {
        wizardData: claimVM,
        updateWizardData,
        history,
        basePath,
        steps,
        goNext,
        currentStepIndex,
        history: {
            location: { state },
        },
    } = props;
    const {
        accountNumber: accountNumberFromPrevPage,
        policyNumber: policyNumberFromPrevPage,
        redirectPath,
        claimNumber,
        claimStatus,
        claimData
    } = state || {};
    const { initializationPath = redirectPath } = state || {};
    const { FNOLService } = useDependencies('FNOLService');
    const { ClaimService } = useDependencies('ClaimService');
    const { AccountService } = useDependencies('AccountService');
    const translator = useTranslator();
    const [policyData, setPolicyData] = useState({});
    const [policyNumber, setPolicyNumber] = useState(policyNumberFromPrevPage);
    const [accountNumber, setAccountNumber] = useState(
        accountNumberFromPrevPage
    );
    const [isLoading, setIsLoading] = useState(false);
    const [isShowInfoMessage, setInfoMessage] = useState(false);
    const [showNoPoliciesError, setShowNoPoliciesError] = useState(false);
    const [showDuplicateErrorMsg, setShowDuplicateErrorMsg] = useState(false);
    const [lossDateChange, setlossDateChange] = useState();
    const [DateChanged, setDateChanged] = useState(false);
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const authUserData = _.get(useAuthentication(), 'authUserData');
    // const { authHeader, authUserData } = useAuthentication();
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
    const isCEAM = appConfig.applicationDetails.applicationName === 'CustomerEngage Account Management'
    const { onValidate, isComponentValid, registerComponentValidation } =
        useValidation('FNOLSelectPolicy');
    const viewModelService = useContext(ViewModelServiceContext);
    const [policySearchCriteriaVM, setPolicySearchCriteriaVM] = useState({});
    const [isAPICallInProgress, setAPICallInProgress] = useState(false);
    const LOB_CODE_NAME_MAP = new Map([
        ["HO", "Homeowners"],
        ["PA", "PersonalAuto"],
        ["GL", "GeneralLiability"],
        ["BO", "BusinessOwners"],
        ["IM", "InlandMarine"],
        ["CP", "CommercialProperty"],
        ["CPKG", "CommercialPackage"],
        ["CA", "CommercialAuto"],
        ["WC", "WorkersComp"],
        ["TRVL", "travel_perLine"],
        ["PUL", "PersonalUmbrellaLine"]
    ]);

    const getFormattedDate = useCallback((items, index, property) => {
        if (typeof items[property.id] === 'undefined') {
            return '';
        }

        return (
            <FormattedDate
                value={new Date(items[property.id])}
                displayFormat="short"
            />
        );
    }, []);

    const getAddressByName = (address) => {
        if(!isTFPA){
            const index = address.indexOf(",");
            const addressLine1 = address.substring(0, index);

            return addressLine1
        }

        return address
    }

    const processResponseData = useCallback(accountDetails => {
        const policyDetails = [];

        if (appConfig.persona === 'policyholder') {
            accountDetails.forEach(policyInfo => {
                const { isCancelled } = policyInfo;
                const effDate = isCancelled ? moment(policyInfo.periodStartDate_TWIA) : moment(policyInfo.effectiveDate);
                const expDate = isCancelled ? moment(policyInfo.cancelledOrExpirationDate_TWIA) : moment(policyInfo.expirationDate);
                const policy = {
                    product: policyInfo.policyNumber,
                    policyNumber: policyInfo.policyNumber,
                    productType: policyInfo.policyType,
                    effectiveDate: effDate,
                    expirationDate: expDate,
                    primaryInsuredName: policyInfo.insured,
                    mailingAddress: getAddressByName(policyInfo.address),
                    isDuplicateClaim: policyInfo.isDuplicateClaim
                };

                policyDetails.push(policy);
            });
        } else {
            const lobindex = 0;
            const allowedPolicy = appConfig.allowedPolicyTypes;

            accountDetails.policySummaries.forEach(policyInfo => {
                const { isCancelled } = policyInfo;
                const businessLines = policyInfo.policyLines;
                const { productName } = policyInfo.product;
                const businessLine = businessLines[lobindex].lineOfBusinessCode;
                const effDate = isCancelled ? moment(policyInfo.periodStartDate_TWIA) : moment(policyInfo.effective);
                const expDate = isCancelled ? moment(policyInfo.cancelledOrExpirationDate_TWIA) : moment(policyInfo.expiration);
                const lossDate = moment(_.get(claimVM.value, 'lossDate'));

                if (
                    productName !== 'Commercial Package' &&
                    _.includes(allowedPolicy, businessLine) && _.get(claimVM.value, 'lossDate') &&
                    lossDate.isBefore(expDate, 'day') && lossDate.isSameOrAfter(effDate, 'day') && !(moment().isBefore(effDate))
                ) {
                    const address = policyInfo.accountHolder?.primaryAddress
                    const policy = {
                        product: policyInfo.policyNumber,
                        policyNumber: policyInfo.policyNumber,
                        productType: businessLine,
                        effectiveDate: effDate,
                        expirationDate: expDate,
                        primaryInsuredName: policyInfo.primaryInsuredName,
                        mailingAddress: isTFPA ? address?.displayName : address.addressLine1,
                        isDuplicateClaim: policyInfo.isDuplicateClaim
                    };

                    policyDetails.push(policy);
                }
            });
        }

        if (policyDetails.length === 0) {
            setShowNoPoliciesError(true);
        }

        return policyDetails;
    }, [claimVM.value]);

    const checkPageSkipped = useCallback(() => {
        const stepsWithoutSelectPolicy = steps.slice(1, steps.length);

        return (
            basePath !== '/fnol-select-policy' &&
            !stepsWithoutSelectPolicy.some(step => step.visited) 
        );
        
    }, [basePath, steps]);

    const setsinglePolicy = (data) => {
        if (data && data.length === 1) {
            onPolicySelect(data[0].policyNumber);
        }
    }

    
    const convertToUTCdate = useCallback((d) => {
        const utcDate = new Date(d.getUTCFullYear(), d.getUTCMonth(),
            d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(),
            d.getUTCMilliseconds());

        return new Date(utcDate.setMinutes(1)).toISOString();
    }, []);

    const getPolicyDetails = useCallback(
        selectedAccountNumber => {
            if (!checkPageSkipped() || _.isEmpty(policyData)) {
                if (appConfig.persona === 'policyholder') {
                    const lossDateValue = _.get(claimVM.value, 'lossDate')
                    const policySearchCriteria = {
                        lossDate: convertToUTCdate(new Date(lossDateValue)),
                        associationName_TWIA: authUserData?.associationName_TWIA
                    };

                    FNOLService.searchPolicies(
                        policySearchCriteria,
                        authHeader
                    ).then(response => {
                        const policyData = processResponseData(response);
                        setPolicyData(policyData);
                        setsinglePolicy(policyData);
                        setIsLoading(false);
                    });
                } else if(authHeader) {
                    AccountService.getAccountDetails(
                        selectedAccountNumber,
                        authHeader
                    ).then(response => {
                        const data = processResponseData(response)

                        setPolicyData(data);
                        setsinglePolicy(data);
                        setIsLoading(false);
                    });
                }
            }
        },
        [checkPageSkipped, policyData, claimVM.value, convertToUTCdate, FNOLService, authHeader, processResponseData, AccountService, setsinglePolicy]
    );

    const redirectDraftClaimFlow = useCallback(() => {
        setIsLoading(true);

        if (_.isFunction(ClaimService.addRecentlyViewedClaim)) {
            ClaimService.addRecentlyViewedClaim(claimNumber, authHeader);
        }

        return FNOLService.getClaim(claimNumber, authHeader).then(
            getClaimResponse => {
                setPolicyNumber(getClaimResponse.policy.policyNumber);
                claimVM.value = getClaimResponse;

                const normalizedLobCode = getNormalizedLOBName(
                    claimVM.value.policy.policyType
                );

                return history.push({
                    pathname: `/fnol-${normalizedLobCode}`,
                    state: {
                        claimData: getClaimResponse,
                        redirectPath,
                        claimStatus,
                    },
                });
            }
        );
    }, [
        ClaimService,
        FNOLService,
        claimNumber,
        authHeader,
        claimVM,
        history,
        redirectPath,
        claimStatus,
    ]);

    useEffect(() => {
        if (!_.isEmpty(claimNumber)) {
            redirectDraftClaimFlow();
        }

        // if (checkPageSkipped()) {
        //     goNext();
        // }

        if( !steps[0].submitted) {
            goNext()
        }
    }, []);

    useEffect(() => {
        setPolicyData({});
        setIsLoading(true);

        const previousAccountNumber = _.get(
            claimVM.value,
            'policy.accountNumber'
        );

        const policyNumberVar = _.isNil(policyNumber)
            ? _.get(claimVM.value, 'policy.policyNumber')
            : policyNumber;

        if (_.isEmpty(_.get(claimVM.value, 'claimNumber'))) {
            _.unset(claimVM.value, 'policy');
            _.unset(claimVM.value, 'selectedPolicy');
        } else {
            _.set(claimVM.value, 'selectedPolicy', policyNumberVar);
        }

        _.set(claimVM, 'lossDate.value', lossDateChange)

        if (claimData && !_.isUndefined(claimData.lossDate) && _.isUndefined(claimVM.lossDate.value)) {
            const prevLossDate = claimData.lossDate;

            claimVM.lossDate.value = prevLossDate;
        }


        setPolicyNumber(policyNumberVar);
        setAccountNumber(accountNumberFromPrevPage || previousAccountNumber);
        setShowNoPoliciesError(false);
        setShowDuplicateErrorMsg(false);

        const flowCheck = initializationPath ? initializationPath.split('/') : redirectPath.split('/');
        const lossDate = claimVM.lossDate.value

        if (lossDate && _.get(claimVM, 'lossDate.aspects.valid')) {
            if (
                (flowCheck[1] === 'policies' &&
                    claimStatus !==
                    translator({
                        id: 'typekey.ClaimState.draft',
                        defaultMessage: 'draft',
                    }) &&
                    (!_.isEmpty(policyNumberVar) || !_.isEmpty(_.get(claimVM.value, 'claimNumber'))))
            ) {
                const aDate = moment(_.get(claimVM.value, 'lossDate'));
                const policySearchCriteria = {
                    lossDate: aDate,
                    policyNumber: policyNumberVar,
                    associationName_TWIA: authUserData?.associationName_TWIA
                };

                if(authHeader) {

                FNOLService.searchPolicies(
                    policySearchCriteria,
                    authHeader
                ).then(response => {
                    const policyDetails = [];

                    response.forEach(policyInfo => {
                        const { isCancelled } = policyInfo;
                        const effDate = isCancelled ? moment(policyInfo.periodStartDate_TWIA) : moment(policyInfo.effectiveDate);
                        const expDate = isCancelled ? moment(policyInfo.cancelledOrExpirationDate_TWIA) : moment(policyInfo.expirationDate);
                
                        const policy = {
                            product: policyInfo.policyNumber,
                            policyNumber: policyInfo.policyNumber,
                            productType: policyInfo.policyType,
                            effectiveDate: effDate,
                            expirationDate: expDate,
                            primaryInsuredName: policyInfo.insured,
                            mailingAddress: appConfig.persona === 'policyholder'
                                ? getAddressByName(policyInfo.propertyAddress) : getAddressByName(policyInfo.address),
                            isDuplicateClaim: policyInfo.isDuplicateClaim
                        };

                        policyDetails.push(policy);
                    });

                    if (policyDetails.length === 0) {
                        setShowNoPoliciesError(true);
                    }

                    setPolicyData(policyDetails);

                    if (policyDetails.length === 1) {
                        onPolicySelect(policyNumberVar);
                    }

                    setIsLoading(false);
                });
            }
            }
            else if (
                (flowCheck[1] === 'accounts' &&
                    (!_.isEmpty(accountNumberFromPrevPage) ||
                        !_.isEmpty(previousAccountNumber) || !_.isEmpty(flowCheck[2]))) ||
                appConfig.persona === 'policyholder'
            ) {
                getPolicyDetails(
                    accountNumberFromPrevPage || previousAccountNumber || flowCheck[2]
                );
            } 
            else if (flowCheck[1] === 'claims' && _.isEmpty(policySearchCriteriaVM)) {
                const localeService = ServiceManager.getService('locale-service');
                const policySearchCriteriaVm = viewModelService.create(
                    { country: localeService.getDefaultCountryCode() },
                    'cc',
                    'edge.capabilities.claim.fnol.policy.dto.PolicySearchCriteriaDTO'
                );
                if (policyNumberVar && !isCEAM && steps[currentStepIndex + 1]?.visited) {
                    _.set(policySearchCriteriaVm, 'policyNumber.value', policyNumberVar);
                    handlePolicySearchByNumber(policyNumberVar);
                }
                setPolicySearchCriteriaVM(policySearchCriteriaVm);
            }
            else {
                setIsLoading(false);
            }
        }

        updateWizardData(claimVM);
        setIsLoading(false);
        // This will call only once.
    }, [claimVM.lossDate.value]);

    const changePolicy = useCallback(() => {
        const prevLossDate = _.get(claimVM, 'lossDate.value');

        // const previousLossDate = convertToUTCdate(new Date(prevLossDate));

        claimVM.value = new Claim();
        _.set(claimVM.value, 'lossDate', prevLossDate);
        updateWizardData(claimVM);
    }, [claimVM, updateWizardData]);

    const callSearchPolicyService = useCallback((isPolicyNumChanged) => {
        setIsLoading(true);

        const lossDate = _.get(claimVM.value, 'lossDate');
        const aDate = moment(lossDate);
        const policySearchCriteria = {
            policyNumber,
            lossDate: aDate,
            associationName_TWIA: authUserData?.associationName_TWIA

        };

        FNOLService.searchPolicies(
            policySearchCriteria,
            authHeader
        ).then(async (policyResponse) => {
            const flowCheck = redirectPath.split('/');

            if (flowCheck[1] === 'accounts') {
                if(authHeader) {
                    const response = await AccountService.getAccountDetails(flowCheck[2], authHeader);
                    const data = processResponseData(response)
                    setPolicyData(data);
                    setsinglePolicy(data);
                }
            }

            if (
                _.isEmpty(policyResponse) &&
                basePath === '/fnol-select-policy'
            ) {
                setInfoMessage(true);

                return claimVM;
            }

            if (_.isEmpty(policyResponse)) {
                setInfoMessage(true);

                return false;
            }

            if (policyResponse[0].isDuplicateClaim) {
                setShowDuplicateErrorMsg(true);
                _.set(claimVM.value, 'selectedPolicy', policyResponse[0].policyNumber);

                return false;
            }

            if (_.get(claimVM.value, 'claimNumber') && !isPolicyNumChanged) {
                const claimObj = _.clone(claimVM.value);
                _.set(claimVM, 'value', claimObj);
                updateWizardData(claimVM);
                goNext();
                return claimVM;
            }

            _.set(claimVM.value, 'policy', policyResponse[0]);
            _.set(claimVM.value, 'policy.accountNumber', accountNumber);

            const normalizedLobCode = getNormalizedLOBName(
                claimVM.value.policy.policyType
            );
            let fnolLOBPath = `/fnol-${normalizedLobCode}`;

            if (isTFPA) {
                fnolLOBPath = `/fnol-tfpa-${normalizedLobCode}`
            }

            // if the URL contains the lob code, we have already navigated from the first step
            // and do not need to force the redirect to `/fnol-${normalizedLobCode}`
            // if (history.location.pathname.includes(fnolLOBPath)) {
            //     return claimVM;
            // }
            if (_.get(claimVM, 'lobs.commercialProperty.value')) {
                if (!claimVM.lobs.commercialProperty.dateOfNotice.value) {
                    claimVM.lobs.commercialProperty.dateOfNotice.value = claimVM.lossDate.value;
                }
            }

            if (appConfig.persona === 'policyholder') {
                _.set(claimVM.value, 'howReported', 'ClaimPortalPolicyholder_Ext');
                _.set(claimVM.value, 'lossType', 'PR');
                _.unset(claimVM.value, 'selectedPolicy');
            } else {
                _.set(claimVM.value, 'howReported', 'ClaimPortalAgent_Ext');
            }

            if (!_.isString(_.get(claimVM, 'lossDate.value'))) {
                _.set(claimVM, 'lossDate.value', moment(_.get(claimVM, 'lossDate.value')).format("YYYY-MM-DD"));
            }

            claimVM.value = new Claim(claimVM.value);

            const lossDateValue = _.get(claimVM, 'lossDate.value');

            if(DateChanged) {
            const convertedLossDate = convertToUTCdate(new Date(lossDateValue));

            _.set(claimVM, 'lossDate.value', convertedLossDate);
           
            }

            if (!_.isUndefined(claimVM.lossDamagesExt.value)) {
                _.set(claimVM, 'lossDamagesExt.value', undefined);
            }

            if (!_.isUndefined(_.get(claimVM.value, 'lobs.homeowners'))) {
                _.set(claimVM, 'lobs.homeowners.propertyFireDamage.value', undefined);
                _.set(claimVM, 'lobs.homeowners.propTheftVanDamageDTO_TFPA.value', undefined);
                _.set(claimVM, 'lobs.homeowners.propertyWaterDamage.value', undefined);
            }
            
            _.set(claimVM, 'lossLocation.value', undefined);

            if(_.get(claimVM.value, 'mainContact') && !_.get(claimVM.value, 'mainContact.primaryPhoneType')) {
                _.set(claimVM.value, 'mainContact.primaryPhoneType', 'home')
            }

          _.set(claimVM, 'associationName_TWIA', authUserData?.associationName_TWIA)
         
          
            return FNOLService.getFNOLDetails(
                policyNumber,
                claimVM.value,
                authHeader
            )
                .then(async (response) => {
                    if (steps.length === 1) {
                        await history.push({
                            pathname: fnolLOBPath,
                            state: {
                                claimData: response,
                                redirectPath,
                                initializationPath
                            },
                        })
                    } else {
                         const claimObj = _.clone(claimVM.value);

                        _.set(claimVM, 'value', response);

                        if(!_.isUndefined(claimObj.mainContact)) {
                        _.set(claimVM, 'mainContact.value', claimObj.mainContact)
                        }
                        
                        goNext()
                    }
        })
                .finally(() => {
                    setIsLoading(false);

                });
        }).finally(() => {
            setIsLoading(false);

        });
    }, [claimVM, policyNumber, FNOLService, authHeader, redirectPath, basePath, accountNumber, 
        isTFPA, convertToUTCdate, AccountService, processResponseData, setsinglePolicy, history]);

    const onNext = useCallback(() => {

        const prevPolicyNo = _.get(claimVM.value, 'policy.policyNumber');

        if (
            !_.isEmpty(prevPolicyNo) &&
            !_.isEmpty(policyNumber) &&
            prevPolicyNo !== policyNumber
        ) {
            return showConfirm({
                title: messages.policyChangeModalTitle,
                message: messages.policyChangeModalMessage,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.changePolicyButtonlabel,
                cancelButtonText: messages.fnolMessagePopupCancel,
            }).then(results => {
                if (results === 'cancel' || results === 'close') {
                    return _.noop();
                }

                changePolicy();

                return callSearchPolicyService(true);
            }, _.noop);
        }

        callSearchPolicyService();
    }, [
        callSearchPolicyService,
        changePolicy,
        claimVM,
        policyNumber,
        showConfirm,
    ]);

    const onPolicySelect = useCallback(
        selectedValue => {
            if (_.get(claimVM.value, 'policy.accountNumber')) {
                setAccountNumber(_.get(claimVM.value, 'policy.accountNumber'));
            }

            _.set(claimVM.value, 'selectedPolicy', selectedValue);
            setShowDuplicateErrorMsg(false);
            updateWizardData(claimVM);
            setPolicyNumber(selectedValue);
        },
        [claimVM, updateWizardData]
    );

    const getCell = useCallback((item, index, property) => <span>{item[property.id]}</span>, []);


    const getAddressLine = useCallback((item) => <span>{item.primaryRiskLocation_TWIA.addressLine1}</span>, []);


    const generateDataForRadioButton = useCallback(row => ({
        code: row.policyNumber,
        value: '',
    }), []);

    const getProductImage = useCallback(item => {
        const flowCheck = redirectPath.split('/');
        let icon;
        const lobName = _.toUpper(getNormalizedLOBName(item.productType));

        if (flowCheck[1] === 'accounts') {
            icon = LobIconUtil.getFontIcon(item.productType);
        } else {
            icon = LobIconUtil.getFontIcon(LOB_CODE_NAME_MAP.get(lobName));
        }

        return <Icon icon={icon} title={item.productCode} />;
    }, [LOB_CODE_NAME_MAP, redirectPath]);

    const dateIsInFuture = useCallback(date => {
        if (!date) {
            return false;
        }

        const currentTime = new Date();
        const selectedDate = moment(date);

        return selectedDate > currentTime;
    }, []);

    const isPageValid = useCallback(() => {
        if (
            _.isEmpty(_.get(claimVM.value, 'selectedPolicy') || showDuplicateErrorMsg)
        ) {
            return false;
        }

        if (
            !_.get(claimVM.value, 'lossDate') ||
            dateIsInFuture(_.get(claimVM.value, 'lossDate'))
        ) {
            return false;
        }

        return true;
    }, [claimVM.value, dateIsInFuture, showDuplicateErrorMsg]);

    useEffect(() => {
        registerComponentValidation(isPageValid);
    }, [isPageValid, registerComponentValidation]);

    const getPolicyNumberHeading = useCallback(() => {
        const previousPolicyNumber = _.get(
            claimVM.value,
            'policy.policyNumber'
        );
        const policyNumberToDisplay =
            policyNumber || previousPolicyNumber || '';

        return translator(messages.lossInformation, {
            policyNumber: policyNumberToDisplay,
        });
    }, [claimVM.value, translator, policyNumber]);

    const getPolicyList = useCallback((request) => {
        setShowNoPoliciesError(false);
        setAPICallInProgress(true);
    
        FNOLService.searchPolicies(
            request,
            authHeader
        ).then(response => {
            const policyDetails = [];

            response.forEach(policyInfo => {
                const policy = {
                    product: policyInfo.policyNumber,
                    policyNumber: policyInfo.policyNumber,
                    productType: policyInfo.policyType,
                    effectiveDate: policyInfo.effectiveDate,
                    expirationDate: policyInfo.expirationDate,
                    primaryInsuredName: policyInfo.insured,
                    mailingAddress: appConfig.persona === 'policyholder'
                        ? getAddressByName(policyInfo.propertyAddress) : getAddressByName(policyInfo.address),
                    isDuplicateClaim: policyInfo.isDuplicateClaim
                };
                const effDate = moment(policyInfo.effectiveDate);
                const expDate = moment(policyInfo.expirationDate);
                const lossDate = moment(_.get(claimVM.value, 'lossDate'));

                if (lossDate.isBefore(expDate) && lossDate.isSameOrAfter(effDate, 'day') && !(moment().isBefore(moment(effDate)))) {
                    policyDetails.push(policy);
                }
            });

            if (policyDetails.length === 0) {
                setShowNoPoliciesError(true);
            }

            setPolicyData(policyDetails);
            setAPICallInProgress(false);

            if (policyDetails.length === 1) {
                onPolicySelect(policyDetails[0]?.policyNumber);
            }

        });
    }, [FNOLService, authHeader, claimVM.value, onPolicySelect]);

    const handlePolicySearchByNumber = useCallback((policyNumberVar) => {
        const aDate = moment(_.get(claimVM.value, 'lossDate'));
        const policySearchCriteria = {
            lossDate: aDate,
            policyNumber: _.get(policySearchCriteriaVM.value, 'policyNumber') || policyNumberVar,
            associationName_TWIA: authUserData?.associationName_TWIA
        };

        getPolicyList(policySearchCriteria);
    }, [claimVM.value, policySearchCriteriaVM.value, getPolicyList]);

    const handleSearchPolicyByDetails = useCallback(() => {
        const { policyNumber, useInsuredAddressExt, streetNameExt, streetNumberExt, zip, country,
            companyNameExt, firstName, lastName, city, state: stateName } = _.get(policySearchCriteriaVM, 'value');
        const aDate = moment(_.get(claimVM.value, 'lossDate'));
        const policySearchCriteria = {
            lossDate: aDate,
            policyNumber,
            associationName_TWIA: authUserData?.associationName_TWIA,
            policyType: null,
            firstName,
            lastName,
            companyNameExt,
            useInsuredAddressExt,
            streetNameExt,
            streetNumberExt,
            state: stateName,
            country,
            city,
            ...(!!zip && {zip}),
        };

        getPolicyList(policySearchCriteria);
    }, [policySearchCriteriaVM, claimVM.value, getPolicyList]);

    const getMailingOrPolHoldAddressColumnHeader = useCallback(() => {
        if (appConfig.persona === 'policyholder') {
            if (isTFPA) {
                return translator(messages.mailingAddress);
            }
            return translator(messages.lossLocationAddress);
        }

        return translator(messages.mailingAddress);
    }, [translator]);

    const getPolicyTableHeadingId = useCallback(() => {
        if (appConfig.persona === 'policyholder' || isTFPA || isCEAM) {
            return translator(messages.policyVerificationTitle);
        }

        return translator(messages.selectPolcicy);
    }, [isCEAM, isTFPA, translator]);

    const handleLossDateChange = (value, path) => {
        _.set(claimVM, path, value);

        const flowCheck = initializationPath ? initializationPath.split('/') : redirectPath.split('/');
        const lossDate = claimVM.lossDate.value

        setlossDateChange(value);
        setDateChanged(true);
        
        if (lossDate && _.get(claimVM, 'lossDate.aspects.valid')) {
            if (flowCheck[1] === 'claims' && isCEAM) {
                const localeService = ServiceManager.getService('locale-service');
                const aDate = moment(_.get(claimVM.value, 'lossDate'));
                const policySearchCriteriaVm = viewModelService.create(
                    {
                        country: localeService.getDefaultCountryCode(),
                        lossDate: aDate,
                    },
                    'cc',
                    'edge.capabilities.claim.fnol.policy.dto.PolicySearchCriteriaDTO'
                );

                setPolicySearchCriteriaVM(policySearchCriteriaVm);
                getPolicyList(policySearchCriteriaVm.value);
            }
        }

        updateWizardData(claimVM)
    }

    const getSearchContainerVisibility = () => {
        const hasLossDateUpdated = !!claimVM.lossDate?.value
        const isFromClaims = initializationPath && initializationPath.split('/')[1] === 'claims';


        return hasLossDateUpdated && isFromClaims && !isCEAM
    }

    const getSubHeaderVisibility = () => (appConfig.persona === 'policyholder' || isCEAM) && policyData.length > 0

    const overrides = {
        policyTable: {
            data: policyData,
        },
        lossDateId: {
            required: true,
            showRequired: true,
            phoneWideTime: {
                labelPosition: 'top',
            },
            onValueChange: handleLossDateChange
        },
        policyTableHeadingId: {
            visible: policyData.length > 0,
            content: getPolicyTableHeadingId()
        },
        policyHeaderSubText: {
            visible: getSubHeaderVisibility()
        },
        policyLossDateHeadingId: {
            content: getPolicyNumberHeading(),
        },
        duplicateClaimsNotification: {
            visible: showDuplicateErrorMsg
        },
        policySelectRadio: {
            option: generateDataForRadioButton,
            value:
                (!_.isEmpty(claimVM.value) &&
                    _.get(claimVM.value, 'selectedPolicy')),
            onValueChange: onPolicySelect,
        },
        noPolicyInfoLableId: {
            visible: isShowInfoMessage,
        },
        noPoliciesNotification: {
            visible: showNoPoliciesError && !policyData?.length
        },
        policySearchContainer: {
            visible: getSearchContainerVisibility(),
            lossDate: claimVM.lossDate?.value,
            isValidLossDate: _.get(claimVM, 'lossDate.aspects.valid'),
            policySearchCriteriaVM,
            setPolicySearchCriteriaVM,
            handlePolicySearchByNumber,
            setPolicyData,
            policyData,
            handleSearchPolicyByDetails,
            isAPICallInProgress
        },
        mailingAddress: {
            header: getMailingOrPolHoldAddressColumnHeader()
        },
        questionContactInfo: {
            visible: appConfig.persona !== 'policyholder' && !isTFPA
        },
        duplicateClaimInfo: {
            content: (isTFPA && appConfig.persona !== 'policyholder' && !isCEAM) ? translator(messages.duplicateMessageInfoTFPA) : translator(messages.duplicateMessageInfo)
        }
    };
    
    const resolvers = {
        resolveCallbackMap: {
            getCell,
            getFormattedDate,
            getProductImage,
            getAddressLine
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            fnolPolicySearch: FNOLPolicySearch,
        },
    };

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    return (
        <WizardPage
            onNext={onNext}
            showPrevious={false}
            disableNext={!isComponentValid || showDuplicateErrorMsg}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                onValidationChange={onValidate}
            />
        </WizardPage>
    );
}

FNOLSelectPolicy.propTypes = wizardProps;
FNOLSelectPolicy.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
};

export default withRouter(FNOLSelectPolicy);